import { LitElement as p, css as b, unsafeCSS as _, html as x } from "lit";
import { property as d } from "lit/decorators/property.js";
import m, { generator as g } from "@smartdesign/list-item";
class C {
  getOffsetForIndexAndAlignment(e, t, i, n, s, a) {
    const f = Math.max(0, a * n), u = Math.min(f, e * n), c = Math.max(0, e * n - s + n);
    switch (t) {
      case "start":
        return u;
      case "end":
        return c;
      case "center": {
        const I = Math.round(c + (u - c) / 2);
        return I < Math.ceil(s / 2) ? 0 : I > f + Math.floor(s / 2) ? f : I;
      }
      case "auto":
      default:
        return i >= c && i <= u ? i : i < c ? c : u;
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debounce(e) {
    let t;
    return (...i) => {
      t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame(() => {
        e(...i), t = null;
      });
    };
  }
}
const w = new C();
class T {
  constructor(e = 100, t = 5) {
    this.pageSize = e, this.preloadedItemsCount = t, this._finalSizeIsKnown = !1, this._itemCache = [], this._lastRequestedFirstIndex = 0, this._lastRequestedLastIndex = 0, this._lastLoadedIndex = 0, this.handleListDataRequest = (i) => {
      const { startIndex: n, stopIndex: s } = i.detail;
      this._lastRequestedFirstIndex = n, this._lastRequestedLastIndex = s, this._list.items = this._itemCache.slice(n, s + 1), !this.finalSizeIsKnown && this._lastLoadedIndex < s + this.preloadedItemsCount && this.requestData();
    }, this.itemCount = e;
  }
  get currentPage() {
    return this.items.length == 0 && this.finalSizeIsKnown ? 0 : Math.floor((this.items.length - 1) / this.pageSize);
  }
  get finalSizeIsKnown() {
    return this._finalSizeIsKnown;
  }
  set finalSizeIsKnown(e) {
    this._finalSizeIsKnown = e, e && (this.itemCount = this._itemCache.length), this._list && (this._list.finalSizeIsKnown = e);
  }
  get itemCount() {
    return this._itemCount;
  }
  set itemCount(e) {
    this._itemCount = e, this._list && (this._list.itemCount = e);
  }
  get items() {
    return this._itemCache;
  }
  set items(e) {
    this._itemCache = e, this.onItemsChange();
  }
  addItems(e) {
    this._itemCache = this._itemCache.concat(e), this.onItemsChange();
  }
  connectList(e) {
    this._list && this._list.removeEventListener("data-request", this.handleListDataRequest), this._list = e, e.itemCount = this.itemCount, e.addEventListener("data-request", this.handleListDataRequest), e.finalSizeIsKnown = this._finalSizeIsKnown;
  }
  onItemsChange() {
    this._pendingDataRequest = !1, this._lastLoadedIndex = this._itemCache.length - 1, this.finalSizeIsKnown ? this.itemCount = this._itemCache.length : this._lastLoadedIndex > this.itemCount && (this.itemCount = this._lastLoadedIndex), this._list && (this._list.items = this._itemCache.slice(this._lastRequestedFirstIndex, this._lastRequestedLastIndex + 1));
  }
  requestData() {
    if (!this._pendingDataRequest)
      if (this.onDataRequest)
        this._pendingDataRequest = !0, this.onDataRequest(this.currentPage + 1), this._lastLoadedIndex += this.pageSize - 1, this._lastLoadedIndex > this.itemCount && (this.itemCount = this._lastLoadedIndex);
      else
        throw Error(
          "The final size is not yet known and the list would require item data from index " + this._lastRequestedFirstIndex + ". to " + this._lastRequestedLastIndex + ". which is not possible to load without a configured onDataRequest"
        );
  }
}
const y = ":host{display:block;position:relative;contain:layout}:host(:focus){outline:none}:host(:focus-visible) ::slotted([focused]){box-shadow:0 0 0 1px #1467ba inset}.container{width:100%}.container>::slotted(*){width:100%;position:absolute;box-sizing:border-box}.container>::slotted(:not([last])){border-bottom:1px solid #d9d9d9}";
var S = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (h, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? v(e, t) : e, s = h.length - 1, a; s >= 0; s--)
    (a = h[s]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && S(e, t, n), n;
}, A = /* @__PURE__ */ ((h) => (h.TriggerOnly = "trigger-only", h.Single = "single", h.Multi = "multi", h))(A || {});
let L = 0;
var r;
const o = (r = class extends p {
  constructor() {
    super(), this.items = [], this.selectionType = "trigger-only", this.id = r.ID + "_" + L++, this.role = "listbox", this.itemGenerator = g, this._lastKnownScrollTop = 0, this._lastRenderedScrollTop = 0, this._itemsRenderData = [], this._elementCache = /* @__PURE__ */ new Map(), this._visibleItemsNum = 0, this._selectedIndices = [], this._focusIndex = -1, this._lastKnownHeight = 0, this.onScroll = () => {
      this._lastKnownScrollTop = this.scrollTop;
      const e = this._lastRenderedScrollTop - this._lastKnownScrollTop;
      Math.abs(e) >= this.itemHeight && (this._lastRenderedScrollTop = this._lastKnownScrollTop, this.requestUpdate());
    }, this.handleKeyDown = (e) => {
      let t = !0;
      switch (e.key) {
        case "Down":
        case "ArrowDown":
          this.focusIndex = this.normalizeIndex(this.focusIndex + 1);
          break;
        case "Up":
        case "ArrowUp":
          this.focusIndex = this.normalizeIndex(this.focusIndex - 1);
          break;
        case "Enter":
          this.handleSelection(this.focusIndex, e.metaKey || e.ctrlKey);
          break;
        case "End":
          this.focusIndex = this.itemCount - 1;
          break;
        case "PageDown":
          this.focusIndex = this.normalizeIndex(this.focusIndex + this._visibleItemsNum - 1);
          break;
        case "Home":
          this.focusIndex = 0;
          break;
        case "PageUp":
          this.focusIndex = this.normalizeIndex(this.focusIndex - this._visibleItemsNum + 1);
          break;
        default:
          t = !1;
          break;
      }
      t && (e.preventDefault(), e.stopPropagation());
    }, this._resizeObserver = new ResizeObserver(() => {
      this._lastKnownHeight !== this.offsetHeight && (this._lastKnownHeight = this.offsetHeight, this.requestUpdate());
    });
  }
  get focusIndex() {
    return this._focusIndex;
  }
  set focusIndex(e) {
    if (e >= -1 && e < this.itemCount) {
      const t = this._focusIndex;
      this._focusIndex = e, (e <= this._firstVisibleIndex || this._lastVisibleIndex <= e) && this.scrollToItem(e), t != e && (e == -1 && this.removeAttribute("aria-activedescendant"), this.requestUpdate("focusIndex", t));
    }
  }
  get selectedIndices() {
    return this._selectedIndices;
  }
  set selectedIndices(e) {
    e ? this._selectedIndices = e.map((t) => Number(t)) : this._selectedIndices = [], this.requestUpdate("selectedIndices");
  }
  scrollToItem(e, t = "auto") {
    this.scrollTop = w.getOffsetForIndexAndAlignment(
      this.normalizeIndex(e),
      t,
      this.scrollTop,
      this.itemHeight,
      this.height,
      this.itemCount
    ), this._lastKnownScrollTop = this.scrollTop;
  }
  getListItem(e) {
    return !this.shadowRoot || e < this._firstVisibleIndex || this._lastVisibleIndex < e ? null : this.querySelector(`[item-index="${e}"]`);
  }
  connectedCallback() {
    super.connectedCallback(), this._resizeObserver.observe(this), this.scrollTop !== this._lastKnownScrollTop && (this.scrollTop = this._lastKnownScrollTop, this.requestUpdate());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._resizeObserver.disconnect();
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.addEventListener("scroll", this.onScroll), this.addEventListener("keydown", this.handleKeyDown), this.addEventListener("click", this.handleClick), this.addEventListener("pointerup", (t) => {
      requestAnimationFrame(() => {
        const i = t.target, n = parseInt(i.getAttribute("item-index"));
        Number.isInteger(n) && (this.focusIndex = n), this.updateFocusedItemAttributes();
      });
    }), this.addEventListener("mousedown", (t) => {
      t.button == 1 && t.preventDefault();
    }), this.addEventListener("auxclick", this.handleClick), this.addEventListener("focus", () => {
      this.matches(":focus-visible") && (this.focusIndex == -1 ? (this.selectedIndices && (this.focusIndex = this.selectedIndices[0]), this.focusIndex == -1 && this.itemCount > 0 && (this.focusIndex = 0)) : this.updateFocusedItemAttributes());
    }), this.addEventListener("blur", () => {
      this.focusIndex != -1 && this.updateFocusedItemAttributes();
    }), this.selectedIndices.length > 0 && this.scrollToItem(this.selectedIndices[0], "center");
  }
  updateFocusedItemAttributes() {
    const e = this.getListItem(this.focusIndex);
    e && (this.focusTarget || document.activeElement == this ? (e.setAttribute("focused", ""), this.setAttribute("aria-activedescendant", e.id)) : (e.removeAttribute("focused"), this.removeAttribute("aria-activedescendant")));
  }
  static get styles() {
    return [
      b`
                ${_(y)}
            `
    ];
  }
  render() {
    return this.updateItemsRenderData(), x`
            <div class="container" style="height: ${this.itemCount * this.itemHeight}px">
                <slot name="items"></slot>
            </div>
        `;
  }
  updated(e) {
    if (super.updated(e), this._lastRenderedScrollTop = this._lastKnownScrollTop, this.updateItems(), (this._increaseWidthOnNextRenderIfNeeded || this._reachedMaxWidth) && //
    this._firstVisibleIndex < this._lastVisibleIndex)
      if (this.querySelector("[item-index]"))
        this.adjustWidthIfNeeded();
      else {
        const t = new MutationObserver(() => {
          this.adjustWidthIfNeeded(), t.disconnect();
        });
        t.observe(this);
      }
  }
  adjustWidthIfNeeded() {
    this._increaseWidthOnNextRenderIfNeeded ? (this._increaseWidthOnNextRenderIfNeeded = !1, window.requestAnimationFrame(() => {
      const e = Number.parseInt(getComputedStyle(this).maxWidth) - this.offsetWidth;
      if (e == 0)
        this._reachedMaxWidth = !0, this.enableLineClampOnItemsIfNeeded();
      else {
        this._reachedMaxWidth = !1;
        const t = [...this.querySelectorAll("[item-index]")].map((n) => {
          if (n instanceof m) {
            n.enableLineClamp = !1;
            const s = n.missingWidthForTexts;
            return s > e && (n.enableLineClamp = !0), s;
          }
        }), i = Math.max(...t);
        i > 0 && (this.style.width = `${this.offsetWidth + i}px`);
      }
    })) : this._reachedMaxWidth && this.enableLineClampOnItemsIfNeeded();
  }
  enableLineClampOnItemsIfNeeded() {
    this.querySelectorAll("[item-index]").forEach((e) => {
      e instanceof m && (e.enableLineClamp = e.enableLineClamp || e.missingWidthForTexts > 0);
    });
  }
  /**
   * Searches for list-items where there is a need for an additional width (ellipsis maybe shown) and increases the width of the list,
   * therefore all the content is visible without tooltips. As it can be an expensive task to retrieve the required details, calling
   * this function has an effect only on the very next render. Note that it only works if the virtual-list works with sd-list-item elements.
   * If the maximum width is reached, line clamp is enabled on list items as a last resort approach to show the content if possible.
   */
  increaseWidthOnNextRenderIfNeeded() {
    this._increaseWidthOnNextRenderIfNeeded = !0;
  }
  updateItems() {
    const e = [...this.querySelectorAll("[item-index]")], t = /* @__PURE__ */ new Map(), i = document.createDocumentFragment();
    for (const n of this._itemsRenderData) {
      const s = this.renderItem(n);
      s.parentElement || i.appendChild(s), t.set(n.dataHash, s);
      const a = e.indexOf(s);
      a !== -1 && e.splice(a, 1);
    }
    this.appendChild(i);
    for (const n of e)
      n instanceof m && (n.enableLineClamp = !1), this.removeChild(n);
    t.forEach((n, s) => {
      this._elementCache.set(s, n);
    });
  }
  renderItem({ index: e, top: t, dataHash: i, data: n }) {
    let s;
    return n ? this._elementCache.has(i) ? (s = this._elementCache.get(i), this._elementCache.delete(i)) : (s = this.itemGenerator(n, e), s.setAttribute("slot", "items")) : (s = document.createElement("div"), s.setAttribute("placeholder-item", ""), s.setAttribute("slot", "items")), Object.assign(s.style, {
      transform: `translateY(${t}px)`,
      height: `${this.itemHeight}px`
    }), s.setAttribute("item-index", e.toString()), s.setAttribute("aria-setsize", String(this.finalSizeIsKnown ? this.itemCount : -1)), s.setAttribute("aria-posinset", String(e + 1)), (!s.id || s.id.startsWith(this.id + "_item_")) && (s.id = this.id + "_item_" + e), this.itemCount - 1 == e ? s.setAttribute("last", "") : s.removeAttribute("last"), this.updateSelectedAttribute(e, s), this.updateFocusedAttribute(e, s), s;
  }
  updateFocusedAttribute(e, t) {
    this.focusIndex == e && (this.focusTarget || document.activeElement == this) ? (t.setAttribute("focused", ""), this.setAttribute("aria-activedescendant", t.id)) : t.removeAttribute("focused");
  }
  updateSelectedAttribute(e, t) {
    const i = this.selectedIndices.indexOf(e) !== -1;
    i ? t.setAttribute("selected", "") : t.removeAttribute("selected"), t.setAttribute("aria-selected", String(i));
  }
  updateItemsRenderData() {
    if (this._itemsRenderData = [], this._visibleItemsNum = Math.min(Math.ceil(this.height / this.itemHeight), this.itemCount), this._visibleItemsNum > 0) {
      this._firstVisibleIndex = this.normalizeIndex(Math.floor(this._lastKnownScrollTop / this.itemHeight)), this._lastVisibleIndex = this.normalizeIndex(this._firstVisibleIndex + this._visibleItemsNum);
      const e = this.normalizeIndex(this._firstVisibleIndex - 2), t = this.normalizeIndex(this._lastVisibleIndex + 2);
      this.requestData(e, t);
      for (let i = e; i <= t; i++) {
        const n = i - e, s = this.items[n];
        let a;
        s ? a = JSON.stringify(s) : a = `placeholder-${n}`, this._itemsRenderData.push({
          index: i,
          top: this.itemHeight * i,
          physicalIndex: n,
          dataHash: a,
          data: s
        });
      }
    } else
      this._firstVisibleIndex = 0, this._lastVisibleIndex = 0;
  }
  normalizeIndex(e) {
    return Math.max(0, Math.min(e, this.itemCount - 1));
  }
  get height() {
    return this.offsetHeight;
  }
  requestData(e, t) {
    !Number.isNaN(e) && !Number.isNaN(t) && this.dispatchEvent(
      new CustomEvent("data-request", {
        detail: {
          startIndex: e,
          stopIndex: t
        }
      })
    );
  }
  handleSelection(e, t) {
    if (e < 0 || this.itemCount <= e)
      return;
    const i = e % this._visibleItemsNum, n = this.items[i];
    if (!n || n.disabled)
      return;
    let s = !0;
    if (this.selectionType !== "trigger-only") {
      const a = this.selectedIndices.indexOf(e);
      s = a == -1, s ? this.selectionType === "single" ? this.selectedIndices = [e] : this.selectedIndices.push(e) : this.selectedIndices.splice(a, 1), this.requestUpdate("selectedIndices");
    }
    this.focusIndex = e, this.dispatchSelectionEvent(e, s, t);
  }
  dispatchSelectionEvent(e, t, i) {
    this.dispatchEvent(
      new CustomEvent("selection", {
        detail: { index: e, selected: t, hasModifier: i }
      })
    );
  }
  handleClick(e) {
    const t = e.composedPath().find((i) => i.hasAttribute && i.hasAttribute("item-index"));
    if (t) {
      const i = e.type == "auxclick" && e.button == 1 || e.metaKey || e.ctrlKey;
      (e.button == 0 || e.button == 1) && this.handleSelection(Number(t.getAttribute("item-index")), i);
    }
  }
}, r.ID = "sd-virtual-list", r.ensureDefined = () => {
  m.ensureDefined(), customElements.get(r.ID) || customElements.define(r.ID, r);
}, r);
l([
  d({ type: Number, attribute: "item-height", reflect: !0 })
], o.prototype, "itemHeight", 2);
l([
  d({ type: Number })
], o.prototype, "itemCount", 2);
l([
  d({ type: Array, attribute: !1 })
], o.prototype, "items", 2);
l([
  d({ type: String, attribute: "selection-type", reflect: !0, noAccessor: !0 })
], o.prototype, "selectionType", 2);
l([
  d({ type: String, attribute: !0, reflect: !0 })
], o.prototype, "id", 2);
l([
  d({ type: Boolean, attribute: "focus-target", reflect: !0 })
], o.prototype, "focusTarget", 2);
l([
  d({ type: String, reflect: !0 })
], o.prototype, "role", 2);
l([
  d({ type: Number, attribute: "focus-index", reflect: !0 })
], o.prototype, "focusIndex", 1);
l([
  d({ type: Array, attribute: !1 })
], o.prototype, "selectedIndices", 1);
let q = o;
q.ensureDefined();
export {
  T as ListDataProvider,
  A as SelectionType,
  q as default
};
//# sourceMappingURL=virtual-list.mjs.map
